<template>
<div class="text-center mt-12 mx-auto" style="width:800px">
  <router-link to="/"><h2 style="padding:10px; color:#fff; display: flex; align-items: center; justify-content: center; background-color: #108ee9"><feather-icon icon="HomeIcon" />홈으로</h2>  </router-link>

  <h3 class="mb-8">제18회 한국청소년디자인전람회 입선작</h3>
  <div class="mb-8">
    <p class="mb-8">
      정보화시대에 들어섬에 따라 인터넷의 보급으로 인터넷문화가 많이 확산된 반면, 인터넷 예절의 형성이 잘 안되어있습니다. 최근, 연예인들의 자살과 일부 네티즌들의 마녀사냥등으로 인터넷 악플문제가 새로운 사회문제로 대두되고 있어 서로를 존중하는 아름다운 인터넷 문화로 만들고자 이 공익광고를 기획하였습니다. 악플과 선플로 나누어져 있는 이 포스터들은 혼자 붙여놓아도 독자적으로 의미전달 할 수 있으며, 둘이 붙여 하나의 포스터를 만들수도 있는 시리즈 공익광고포스터입니다. '악플(선플) 당신손에 달려있습니다. 라는 카피에 알맞게 키보드를 두드리려는 손 아래로 꼭두각시가 달려있어 같은손과 꼭두각시지만 사람이 전하려는 말에 따라 대비되는 결과가 나온다는 것을  각각 악마의 형상을 가진 꼭두각시가 키보드를 파괴하는 것과 천사의 형상을 가진 꼭두각시가 좋은 말들로 키보드를 잘 가꾸어가는 것으로 시각화 하여 나타내었습니다.
    </p>
    <img src="https://3201fb16-a-62cb3a1a-s-sites.googlegroups.com/site/myeongstudio/advertising-desing/netikes-gong-igposeuteo/%EB%84%A4%ED%8B%B0%EC%BC%93%EA%B3%B5%EC%9D%B5%ED%8F%AC%EC%8A%A4%ED%84%B0.jpg?attachauth=ANoY7crmEFoZnenzgUf5LnPvhfxYEZGGJPP5DusJ4LIkNZVa3rsWsy49hT6Q_TjokWm6zDuYkAd2wF2492DEPetz7QsXxG4TVvCHEGMOT9E6uONfyi3bII5FFGDYpurIUmu8x_s1tdcG8L9OV1bExsizap4XCxXyyqzI-Q9TNHffzUfEnURqKlYvrtTHAXMSw7zvTQczG6zbtSqzLKgR2Pg6BRr5CPJsCnR9igq09IZQigZtrBF6T62_PFMeILb_RAAa4doRcT3iFoEkIGTSErBxT2gYDI5-ryx06jCoVus6oIlah-I4Q_p9sjzBTlR5kEBqHG0webjvGkJJxpu4LxR_OKQeTNN0oyINtinib2dTAvi2osXxdn8%3D&attredirects=0"/>
  </div>
  <router-link to="/"><h2 style="padding:10px; color:#fff; display: flex; align-items: center; justify-content: center; background-color: #108ee9"><feather-icon icon="HomeIcon" />홈으로</h2>  </router-link>
</div>
</template>

<script>
export default {
  name: 'EventToday'
}
</script>

<style scoped>

</style>
